import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/inventory-report/:reportId',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/InventoryReportContainer',
      './modules/InventoryReport'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const InventoryReport = require('./containers/InventoryReportContainer').default
      const actions = require('./modules/InventoryReport')
      const reducer = require('./modules/InventoryReport').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'inventoryReport', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId, nextState.params.reportId))

      /*  Return getComponent   */
      cb(null, InventoryReport)

    /* Webpack named bundle   */
    }, 'InventoryReport')
  }
})



// WEBPACK FOOTER //
// ./src/routes/InventoryReport/index.js